import { Routes, Route, Navigate } from 'react-router-dom';
import Home from './Home';
import Poc from './Poc';
import LinkedInCallback from './LinkedInCallback';
import NotFound from './NotFound';
// import MRCEditorLoader from './components/MRCEditorLoader'; // Old MRC Editor - removed
import ProductHomepage from './ProductHomepage';
import Codex from "./Codex";
import Codify from "./Codify";
import Panner from "./Panner";
import GRLCPlacementEditorPage from "./GRLCPlacementEditorPage";
import GRLCPlacementEditorPageRefactored from "./GRLCPlacementEditorPageRefactored";
import PartyEditor from './PartyEditor';
import ProductDefinitionEditorPage from './ProductDefinitionEditorPage';
import ContractInstanceEditorPage from './ContractInstanceEditorPage';
import RegistersEditorPage from './RegistersEditorPage';
import DocumentDefinitionsEditorPage from './DocumentDefinitionsEditorPage';
import CodifyDefinitionsEditorPage from './CodifyDefinitionsEditorPage';
import UsersEditorPage from './UsersEditorPage';
import ProtectedRoute from "./ProtectedRoute";
import SignalCreatorPage from "./SignalCreatorPage";
import SmartLedgersEditorPage from './SmartLedgersEditorPage';
import AccountsEditorPage from './AccountsEditorPage';
import JournalsEditorPage from './JournalsEditorPage';
import MyWorkflowDetailPage from './MyWorkflowDetailPage';
import JsonFormRenderer from './JsonFormRenderer';
import DocumentEditorLoader from './components/DocumentEditorLoader';

import "./index.css";   // ✅ this pulls in your CSS globally

const hostname = window.location.hostname;
const isPocEnv = hostname.startsWith('poc.');

function App() {
  return (
    <Routes>
      {/* Dev redirect for case-sensitive URLs */}
      <Route path="/poc" element={<ProtectedRoute><Poc /></ProtectedRoute>} />

      {/* Root route based on environment */}
      <Route path="/" element={isPocEnv ? <Poc /> : <Home />} />

      {/* Functional routes */}
      <Route path="/product/:productCode" element={<ProtectedRoute><ProductHomepage /></ProtectedRoute>} />
      <Route path="/linkedincallback" element={<LinkedInCallback />} />
      {/* Old MRC Editor route - removed, use /editor route for DocumentEditor instead */}
      {/* <Route path="/product/:productCode/contract/:contractId" element={<ProtectedRoute><MRCEditorLoader userRole="broker" /></ProtectedRoute>}/> */}

      <Route path="/editor/:productCode/:contractId" element={<ProtectedRoute><DocumentEditorLoader userRole="editor" /></ProtectedRoute>} />

      <Route path="/codex" element={<ProtectedRoute><Codex /></ProtectedRoute>} />
      <Route path="/codify" element={<ProtectedRoute><Codify /></ProtectedRoute>} />
      <Route path="/panner" element={<ProtectedRoute><Panner /></ProtectedRoute>} />
      <Route path="/product/:productCode/contract/:contractId/placement" element={<ProtectedRoute><GRLCPlacementEditorPage /></ProtectedRoute>} />
      <Route path="/product/:productCode/contract/:contractId/placement-v2" element={<ProtectedRoute><GRLCPlacementEditorPageRefactored /></ProtectedRoute>} />
      <Route path="/product/:productCode/contract/:contractId/contract" element={<ProtectedRoute><ContractInstanceEditorPage /></ProtectedRoute>} />
      <Route path="/product/:productCode/contract/:contractId/signal" element={<ProtectedRoute><SignalCreatorPage /></ProtectedRoute>} />
      <Route path="/party/:partyId" element={<ProtectedRoute><PartyEditor /></ProtectedRoute>} />
      <Route path="/registers/:registerId" element={<ProtectedRoute><RegistersEditorPage /></ProtectedRoute>} />
      <Route path="/documentdefinitions/:documentDefinitionId" element={<ProtectedRoute><DocumentDefinitionsEditorPage /></ProtectedRoute>} />
      <Route path="/codifydefinitions/:codifyDefinitionId" element={<ProtectedRoute><CodifyDefinitionsEditorPage /></ProtectedRoute>} />
      <Route path="/smartledgers/:smartLedgerId" element={<ProtectedRoute><SmartLedgersEditorPage /></ProtectedRoute>} />
      <Route path="/accounts/:accountId" element={<ProtectedRoute><AccountsEditorPage /></ProtectedRoute>} />
      <Route path="/journals/:journalId" element={<ProtectedRoute><JournalsEditorPage /></ProtectedRoute>} />
      <Route path="/users/:userId" element={<ProtectedRoute><UsersEditorPage /></ProtectedRoute>} />
      <Route path="/poc/product/:productCode/edit" element={<ProtectedRoute><ProductDefinitionEditorPage /></ProtectedRoute>} />
      <Route path="/workflow/:id" element={<ProtectedRoute><MyWorkflowDetailPage baseUrl="https://workflow.poc.mrc.ai" /></ProtectedRoute>} />
      <Route path="/workflow/:id/payload" element={<ProtectedRoute><JsonFormRenderer /></ProtectedRoute>} />
      {/* 404 fallback */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default App;
